import React, { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Link, Navigate } from "react-router-dom";

import { notifyInfo, notifyError } from "../../utils/notify";
import styles from "./RegistrationScreen.module.scss";

import Button from "../../components/Button/Button";
import Card from "../../components/Card/Card";
import Input from "../../components/Input/Input";
import { selectChoosenSchool } from "../../store/slices/school/slice";
import { signup } from "../../store/slices/auth/asyncThunks";
import { isValidEmail } from "../../utils/util";

const RegistrationScreen = () => {
  const choosenSchool = useSelector(selectChoosenSchool);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [accessCode, setAccessCode] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const validateData = useMemo(() => {
    if (
      firstName.trim().length > 0 &&
      lastName.trim().length > 0 &&
      email.trim().length > 0 &&
      isValidEmail(email) &&
      password.trim().length > 0 &&
      passwordConfirm.trim().length > 0 &&
      password === passwordConfirm &&
      accessCode.trim().length > 0
    ) {
      return false;
    } else {
      return true;
    }
  }, [firstName, lastName, email, password, passwordConfirm, accessCode]);

  const makeRegistration = () => {
    dispatch(signup({ email, firstName, lastName, password, accessCode })).then(
      (promise) => {
        if (promise.type.includes("fulfilled")) {
          notifyInfo("Successfully registered");
          navigate("/login");
        } else {
          notifyError(promise.error.message);
        }
      }
    );
  };
  return choosenSchool?.name.trim().length > 0 ? (
    <div className={styles.registrationScreenContainer}>
      <div className={styles.card}>
        <Card>
          <div className={styles.registrationCardContainer}>
            <div>
              <h1>Welcome!</h1>
              <h2>Register</h2>
            </div>

            <Input
              placeholder="First Name"
              onChange={(event) => setFirstName(event)}
            ></Input>
            <Input
              placeholder="Last Name"
              onChange={(event) => setLastName(event)}
            ></Input>
            <Input
              placeholder="Email"
              onChange={(event) => setEmail(event)}
            ></Input>
            <Input
              type="password"
              placeholder="Password"
              onChange={(event) => setPassword(event)}
            ></Input>
            <Input
              type="password"
              placeholder="Confirm Password"
              onChange={(event) => setPasswordConfirm(event)}
            ></Input>
            <Input
              placeholder="Access Code"
              onChange={(event) => setAccessCode(event)}
            ></Input>

            <div className={styles.buttonContainer}>
              <Button
                aria-label="Login"
                title="Register"
                disabled={validateData}
                onClick={makeRegistration}
              />
            </div>
          </div>
        </Card>
      </div>
      <div
        style={{
          fontSize: "1.8rem",
          lineHeight: "2.1rem",
          textAlign: "center",
        }}
      >
        <span>Already have an account?</span>
        <Link
          className={styles.forgotPasswordSpanLink}
          to="/login"
          style={{ paddingLeft: "1rem", fontWeight: "bold" }}
        >
          Sign in
        </Link>
      </div>
      <h3>Powered by Aware Technology</h3>
    </div>
  ) : (
    <Navigate to="/login-school" />
  );
};

export default RegistrationScreen;
